/*
 * Free shipping for bundles: adds the SZB-9UFC0MC375 code to the cart when it contains a bundle.
 *
 * The cart qualifies when it has one of the product/variant IDs below, or an Oxify bundle:
 * lines sharing the same "_bundle_id" property with at least MIN_BUNDLE_ITEMS
 * items in total.
 *
 * The code is stored on the cart itself (/cart/update.js "discount"), so it is
 * also used by Shop Pay / express checkout started from the cart.
 */
(function () {
  var DISCOUNT_CODE = 'SZB-9UFC0MC375';
  // Product or variant IDs: any of these in the cart applies the code
  var BUNDLE_IDS = [
    44315869446257,
    67890803474545,
    67890801377393,
    67890797150321,
    67890777686129,
    67890739642481,
    44049608933489,
    // Loop preset bundles (variant IDs), added at cutover
    68009752100977, // Rise & Rest
    68009760850033, // Daily Defense
    68009760915569, // Bright Side
    68009769173105, // Fresh Start
    68009769238641, // Daily Essentials
    68009786310769  // Discovery Six Pack
  ];
  var MIN_BUNDLE_ITEMS = 4;

  function cartHasBundle(cart) {
    var items = cart.items || [];
    var bundleCounts = {};
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (BUNDLE_IDS.indexOf(item.product_id) !== -1 || BUNDLE_IDS.indexOf(item.variant_id) !== -1) return true;
      var bundleId = item.properties && item.properties._bundle_id;
      if (bundleId) bundleCounts[bundleId] = (bundleCounts[bundleId] || 0) + item.quantity;
    }
    return Object.keys(bundleCounts).some(function (id) {
      return bundleCounts[id] >= MIN_BUNDLE_ITEMS;
    });
  }

  function hasCode(cart) {
    return (cart.discount_codes || []).some(function (d) {
      return String(d.code).toUpperCase() === DISCOUNT_CODE;
    });
  }

  var nativeFetch = window.fetch.bind(window);

  // Add SZB-9UFC0MC375 when the cart has a bundle, keeping any other codes the customer used.
  function applyDiscount() {
    return nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cartHasBundle(cart) || hasCode(cart)) return cart;
        var codes = (cart.discount_codes || []).map(function (d) {
          return d.code;
        });
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.concat(DISCOUNT_CODE).join(',') })
        }).then(function (r) {
          return r.json();
        });
      })
      .catch(function () {});
  }

  var timer;
  function scheduleApply() {
    clearTimeout(timer);
    timer = setTimeout(applyDiscount, 300);
  }

  // Re-check after anything changes the cart (theme, Oxify builder, other apps).
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch(input, init);
    if (CART_CHANGE.test(url)) {
      promise.then(scheduleApply, scheduleApply);
    }
    return promise;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_CHANGE.test(String(url))) {
      this.addEventListener('loadend', scheduleApply);
    }
    return nativeOpen.apply(this, arguments);
  };

  // Theme checkout buttons: save the cart form, then go to checkout with the code when the cart has a bundle.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.btn-checkout');
    if (!button || button.disabled) return;
    var form = document.getElementById(button.getAttribute('form'));
    if (!form) return;
    event.preventDefault();

    var formData = new FormData(form);
    nativeFetch(form.action, { method: 'POST', body: formData, credentials: 'same-origin' })
      .then(function () {
        return nativeFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        window.location.href = cartHasBundle(cart) ? '/checkout?discount=' + DISCOUNT_CODE : '/checkout';
      })
      .catch(function () {
        window.location.href = '/checkout';
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDiscount);
  } else {
    applyDiscount();
  }
})();
